import { useRouter } from "next/router";
import { useMemo } from "react";

export function useActivePathCheck() {
  const router = useRouter();

  const activePath = useMemo(() => {
    const path = router.asPath;
    if (path.startsWith("/benefit/prepare-package"))
      return "장례준비 패키지 알아보기";
    else if (path.startsWith("/match/recommendations/")) return "고이의 추천";
    else if (path === "/") return "홈";
    else if (path === "/review/") return "상주분들의 후기";
    else if (path.startsWith("/service/")) return "상조 서비스";
    return "";
  }, [router]);

  return { activePath };
}
